/**
 * @generated SignedSource<<f8cf0f83b5c4e800e095197cdcee0dfa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReviewerDiscussionCardPaginationQuery$variables = {
  count: number;
  userId?: UUID | null | undefined;
};
export type ReviewerDiscussionCardPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ReviewerDiscussionCardPaginationFragment_reviewerDashboardFlowComments">;
};
export type ReviewerDiscussionCardPaginationQuery = {
  response: ReviewerDiscussionCardPaginationQuery$data;
  variables: ReviewerDiscussionCardPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "fields": [
      {
        "fields": [
          {
            "fields": [
              {
                "fields": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "equalTo",
                        "variableName": "userId"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "reviewerId"
                  }
                ],
                "kind": "ObjectValue",
                "name": "some"
              }
            ],
            "kind": "ObjectValue",
            "name": "flowReviewers"
          }
        ],
        "kind": "ObjectValue",
        "name": "flow"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "UNREAD_COMMENTS_CREATED_AT_DESC"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReviewerDiscussionCardPaginationQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "ReviewerDiscussionCardPaginationFragment_reviewerDashboardFlowComments"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReviewerDiscussionCardPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ReviewerDashboardFlowCommentsConnection",
        "kind": "LinkedField",
        "name": "reviewerDashboardFlowComments",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ReviewerDashboardFlowCommentsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReviewerDashboardFlowComment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "comment",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unread",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "commentText",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "GwtUser",
                        "kind": "LinkedField",
                        "name": "gwtUser",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fullName",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "firstName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lanId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Flow",
                    "kind": "LinkedField",
                    "name": "flow",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "linkedType",
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": [
          "orderBy",
          "filter"
        ],
        "handle": "connection",
        "key": "ReviewerDiscussionCardPaginationFragment_reviewerDashboardFlowComments",
        "kind": "LinkedHandle",
        "name": "reviewerDashboardFlowComments"
      }
    ]
  },
  "params": {
    "cacheID": "78c79445c48979d829f9deb6a7432a50",
    "id": null,
    "metadata": {},
    "name": "ReviewerDiscussionCardPaginationQuery",
    "operationKind": "query",
    "text": "query ReviewerDiscussionCardPaginationQuery(\n  $count: Int!\n  $userId: UUID\n) {\n  ...ReviewerDiscussionCardPaginationFragment_reviewerDashboardFlowComments_4irCDR\n}\n\nfragment FlowLink_flow on Flow {\n  rowId\n  linkedType\n}\n\nfragment ReviewerDiscussionCardPaginationFragment_reviewerDashboardFlowComments_4irCDR on Query {\n  reviewerDashboardFlowComments(orderBy: UNREAD_COMMENTS_CREATED_AT_DESC, first: $count, filter: {flow: {flowReviewers: {some: {reviewerId: {equalTo: $userId}}}}}) {\n    edges {\n      node {\n        comment {\n          rowId\n          unread\n          createdAt\n          commentText\n          gwtUser {\n            fullName\n            ...UserAvatar_gwtUser\n            id\n          }\n          id\n        }\n        flow {\n          rowId\n          name\n          ...FlowLink_flow\n          id\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment UserAvatar_gwtUser on GwtUser {\n  id\n  firstName\n  lastName\n  lanId\n}\n"
  }
};
})();

(node as any).hash = "a86426d109660c95083ea361acc531fc";

export default node;
